import * as moment from 'moment-timezone';
import { getTodayDateTimeInSelectedTimeZone } from '../components/Calendar/CalendarHelper';
var DATE_FORMAT = 'YYYY-MM-DD';
export var getDateRangeForListGoEntries = function (officeTimeZone) {
    var officeCurrentDateTime = getTodayDateTimeInSelectedTimeZone(officeTimeZone);
    // query 14 days entries by default; use the showWeekends setting in response to decide calendar view
    var startDate = moment(officeCurrentDateTime.date).isoWeekday(1);
    var endDate = moment(officeCurrentDateTime.date)
        .isoWeekday(1)
        .add(14, 'days');
    return {
        startDate: startDate.format(DATE_FORMAT),
        endDate: endDate.format(DATE_FORMAT),
    };
};
